<a class="comp-gallery d-block position-relative" [ngClass]="(versi == '1')?'ver-1':'ver-2'"  >
    <img [ngClass]="(versi == '1')?'img1':'img2'"  
          class="w-100"
          [src]="apiAsset + dataGallery?.picture"
          [alt]="">
    <div class="overlay-title" *ngIf="versi == '1' && dataGallery?.title">
        <h6 class="tit">{{ dataGallery?.title }}</h6>
        <div class="desc" [innerHTML]="dataGallery?.content"></div>
    </div>
    <div class="detail mt-2" *ngIf="versi == '2'">
        {{ dataGallery?.title }}
    </div>
</a>
